export enum DepotAccessor {
  Index = 'index',
  AssetNumber = 'assetNumber',
  ItemSku = 'items',
  Cost = 'cost',
  Status = 'status',
  CreatedAt = 'createdAt',
}
